import * as React from 'react';
import { Dispatch } from 'redux';
import { ParticipantViewModel } from 'stageclip-common';

import { BaseApiGetRequest } from '../generic/baseApiGetRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';
import * as ParticipantNormalizers from '../normalizers/participantNormalizers';

export class GetAllParticipantsRequest extends BaseApiGetRequest<
  ParticipantViewModel,
  EntityNormalizers.NormalizedEntityArray<ParticipantNormalizers.NormalizedParticipants>
> {
  constructor(eventId: string, component: React.Component, dispatch: Dispatch) {
    super(component, dispatch);
    this.path = `/events/${eventId}/participants`;
    this.normalizeMethod = ParticipantNormalizers.normalizeParticipantsArray;
  }
}
